import { render } from "./VxInputGroup.vue?vue&type=template&id=25b587e4"
import script from "./VxInputGroup.vue?vue&type=script&lang=js"
export * from "./VxInputGroup.vue?vue&type=script&lang=js"

import "./VxInputGroup.vue?vue&type=style&index=0&id=25b587e4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__